import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import ChatsScreen from '~images/chats-page/chats_screen.svg'

const WhatAreChats = () => {
  return (
    <Screen
      title={<span>Что такое<StyledScreen.GreenText> чаты?</StyledScreen.GreenText></span>}
      bottomLine
      className='what-are-chats'
    >
      <div className="what-are-chats__container">
        <p className="what-are-chats__about-text">
          Чаты — это сервис для общения с клиентами в мессенджерах прямо из вашей CRM-системы: голосовые и текстовые коммуникации в одном окне без ограничений по количеству сообщений и диалогов. <br /><br />
          Идеально для клиентов, которые не любят звонить.
        </p>
        <div className="what-are-chats__features">
          <div className="what-are-chats__features-text">
            <h3 className="what-are-chats__features-title">Преимущества чатов:</h3>
            <ul className="what-are-chats__features-list">
              <li className="what-are-chats__features-list-item">Общение с клиентами в WhatsApp и Telegram;</li>
              <li className="what-are-chats__features-list-item">Интеграция с amoCRM и Bitrix24;</li>
              <li className="what-are-chats__features-list-item">До 5 номеров в тарифе для Telegram, 1 номер для WhatsApp;</li>
              <li className="what-are-chats__features-list-item">Возможность писать первыми;</li>
              <li className="what-are-chats__features-list-item">Неограниченное количество сообщений и диалогов;</li>
            </ul>
          </div>
          <div className="what-are-chats__features-img"><ChatsScreen /></div>
        </div>
      </div>
    </Screen>
  )
}

export default WhatAreChats